module.exports = __webpack_public_path__ + "img/38.6c84d084.png";